export const PARTICIPATION_STRATEGIES = {
  SINGLE_STUDENT: "single_student",
  SHARED_STUDENTS: "shared_students",
};

export const PAYMENT_STRATEGIES = {
  ARREARS: "arrears",
  PREPAID: "prepaid",
  INSTALLMENTS: "installments",
};

export const CHARGING_STRATEGIES = {
  FIXED_FEE: "fixed_fee",
  PER_LESSON: "per_lesson",
  CONSUME_PACKAGE_UNITS: "consume_package_units",
};

export const DURATION_POLICIES = {
  FIXED_DATES: "fixed_dates",
  UNTIL_SCHOOL_YEAR_END: "until_school_year_end",
  VALID_FOR_DAYS_OR_MONTHS: "valid_for_days_or_months",
};

export const ENROLLMENT_STATUSES = {
  DRAFT: "draft",
  ACTIVE: "active",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
};

export const SCHEDULE_ITEM_STATUSES = {
  PLANNED: "planned",
  POSTED: "posted",
  PAID: "paid",
  WAIVED: "waived",
  CANCELLED: "cancelled",
  ADJUSTED: "adjusted",
};

export const SCHEDULE_ITEM_SOURCE_TYPES = {
  INSTALLMENT: "installment",
  INITIAL_FEE: "initial_fee",
  MATERIALS_FEE: "materials_fee",
  PREPAID_PACKAGE: "prepaid_package",
};
